'use strict';

angular
  .module('subscriptionPackage')
  .component('subscriptionPackage', {
    template: require('./subscription-package.template.html'),
    controller: ['$rootScope', '$resource', '$translate', 'AuthService', 'envService',
      function SubscriptionPackageController($rootScope, $resource, $translate, AuthService, envService) {
        const APIURL = envService.read('apiUrl');
        const base = `${APIURL}/wash/subscription_payment/package`;

        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'subscriptionPackage';
        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        this.isLevel2Auth = AuthService.isLevel2Authenticated();
        this.saving = false;
        this.packages = [];
        this.goodsOptions = [];
        this.editing = null;

        this._emptyForm = () => ({
          package_id: '',
          nameth: '',
          nameen: '',
          amt_wash: 4,
          price: 0,
          good_id: '',
          img_path: '',
          status: 'A',
          isNew: true,
        });

        this.productLabel = (row) => {
          if (!row) {
            return '';
          }
          if (row.PRODUCT_INCLUDE) {
            return `${row.PRODUCT_INCLUDE} (${row.GOODS_ID || ''})`;
          }
          return row.GOODS_ID || '';
        };

        this.loadGoods = () => {
          $resource(`${base}/admin_goods`).query({ country_code: 'TH' }).$promise
            .then((rows) => {
              this.goodsOptions = Array.isArray(rows) ? rows : [];
            })
            .catch(() => {
              this.goodsOptions = [];
            });
        };

        this.load = () => {
          $resource(`${base}/admin_list`).query().$promise
            .then((rows) => {
              this.packages = Array.isArray(rows) ? rows : [];
            })
            .catch((err) => {
              this.packages = [];
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.openCreate = () => {
          this.editing = this._emptyForm();
          if (this.goodsOptions.length && !this.editing.good_id) {
            this.editing.good_id = this.goodsOptions[0].GOODS_ID;
          }
        };

        this.openEdit = (row) => {
          this.editing = {
            package_id: String(row.PACKAGE_ID || ''),
            nameth: row.NAME_TH || '',
            nameen: row.NAME_EN || '',
            amt_wash: Number(row.AMT_WASH) || 0,
            price: Number(row.PRICE) || 0,
            good_id: row.GOODS_ID || '',
            img_path: row.IMG_PATH || '',
            status: row.STATUS === 'N' ? 'N' : 'A',
            isNew: false,
          };
        };

        this.cancelEdit = () => {
          this.editing = null;
        };

        this.save = () => {
          if (!this.isLevel2Auth || !this.editing) {
            return;
          }
          const form = this.editing;
          if (!form.nameth || !form.nameen || !form.good_id || !(Number(form.amt_wash) > 0)) {
            alert($translate.instant('필수 항목을 입력해주세요.'));
            return;
          }
          this.saving = true;
          const body = {
            package_id: form.package_id || undefined,
            nameth: form.nameth,
            nameen: form.nameen,
            amt_wash: Number(form.amt_wash),
            price: Number(form.price) || 0,
            good_id: form.good_id,
            img_path: form.img_path || '',
            status: form.status === 'N' ? 'N' : 'A',
          };
          const url = form.isNew ? `${base}/admin_create` : `${base}/admin_update`;
          $resource(url, {}, { save: { method: 'POST' } })
            .save(body)
            .$promise
            .then(() => {
              this.editing = null;
              this.load();
              alert($translate.instant('수정되었습니다.'));
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else if (err.data && err.data.error) {
                alert(err.data.error);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            })
            .finally(() => {
              this.saving = false;
            });
        };

        this.deactivate = (row) => {
          if (!this.isLevel2Auth) {
            return;
          }
          if (!confirm($translate.instant('비활성화 하시겠습니까?'))) {
            return;
          }
          $resource(`${base}/admin_delete`, {}, { save: { method: 'POST' } })
            .save({ package_id: row.PACKAGE_ID })
            .$promise
            .then(() => {
              this.load();
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.activate = (row) => {
          if (!this.isLevel2Auth) {
            return;
          }
          $resource(`${base}/admin_update`, {}, { save: { method: 'POST' } })
            .save({
              package_id: row.PACKAGE_ID,
              nameth: row.NAME_TH,
              nameen: row.NAME_EN,
              amt_wash: Number(row.AMT_WASH),
              price: Number(row.PRICE),
              good_id: row.GOODS_ID,
              img_path: row.IMG_PATH || '',
              status: 'A',
            })
            .$promise
            .then(() => {
              this.load();
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.loadGoods();
        this.load();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/subscription-package/subscription-package.component.js